import api from './'

export default {

    /**
     * Get mccs
     * @param params
     */
    get(params = {}) {
        return api
            .get('/mccs', {
                params: params
            })
            .then(response => {
                return response.data
            })
    },

    /**
     * Show mcc
     * @param mcc
     * @param params
     */
    show(mcc, params) {
        return api
            .get(`/mccs/${mccs}`, {
                params: params
            })
            .then(response => {
                return response.data
            })
    }

}
